import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/**
 * Configuration for a Delay task — pauses flow execution for a configurable duration.
 * Actual sleep time = delay (ms) × multiplier. Both fields must be set; 0 or empty throws.
 */
export class DelayConfig extends DestinationTaskConfigBase {
	/**
	 * Base delay duration in milliseconds. Must be greater than 0.
	 * @default 5000
	 */
	delay = 5000;

	/**
	 * Multiplier applied to the base delay. Supports expression syntax for dynamic
	 * back-off (e.g. '{{record.contextData.retryCount}}'). Must be non-empty.
	 * @default '1'
	 */
	multiplier = '1';

	constructor(init?: Partial<DelayConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}
}
